import React from "react";

interface IconProps {
  className?: string;
  color?: string;
}

export function CloseIcon({
  className,
  color = "#696F88",
}: IconProps): JSX.Element {
  return (
    <svg
      className={className}
      width="10.5"
      height="10.5"
      viewBox="0 0 10.5 10.5"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M10.5 1.0575L9.4425 0L5.25 4.1925L1.0575 0L0 1.0575L4.1925 5.25L0 9.4425L1.0575 10.5L5.25 6.3075L9.4425 10.5L10.5 9.4425L6.3075 5.25L10.5 1.0575Z"
        fill={color}
      />
    </svg>
  );
}

export function SmallCloseIcon({
  className,
  color = "currentColor",
}: IconProps): JSX.Element {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1 1L11 11M11 1L1 11"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function CheckIcon({
  className,
  color = "white",
}: IconProps): JSX.Element {
  return (
    <svg
      className={className}
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9.76934 0.149609C9.97049 0.149609 10.0896 0.383699 9.96075 0.544141L9.95977 0.543164L4.23809 7.79609H4.23711C4.02619 8.06094 3.62324 8.06195 3.4129 7.79609L0.202934 3.72969C0.0772537 3.57029 0.190828 3.3353 0.39434 3.33516H1.21368L1.33086 3.34883C1.36937 3.35769 1.4074 3.37051 1.44317 3.38789C1.51435 3.42255 1.57679 3.47315 1.62579 3.53535L3.82403 6.32148L8.53887 0.349805C8.63789 0.223413 8.79006 0.149727 8.95 0.149609H9.76934Z"
        fill={color}
      />
    </svg>
  );
}

export function CollapseArrowIcon({
  className,
  color = "#696F88",
}: IconProps): JSX.Element {
  return (
    <svg
      className={className}
      width="9"
      height="6"
      viewBox="0 0 9 5.5575"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M1.0575 5.5575L4.5 2.1225L7.9425 5.5575L9 4.5L4.5 0L0 4.5L1.0575 5.5575Z"
        fill={color}
      />
    </svg>
  );
}
